module.exports = __webpack_public_path__ + "img/IT0000149981571.3d225848.png";